/* eslint-disable no-nested-ternary */
import { SparklesIcon } from "@heroicons/react/24/outline";
import { useQuery } from "@tanstack/react-query";
import { getUserIncentives } from "apis/user";
import { LoadingIcon } from "components/atoms/Icon";
import IncentivesCard from "components/organisms/activations/IncentivesCard";
import { get } from "utils/request";

function IncentivesPanel() {
  const { data: magnetDataArr, isLoading } = useQuery<any>({
    queryKey: ["user-incentives"],
    queryFn: () => get(getUserIncentives()),
  });

  return (
    <div className="secondary-scrollbar shrink-0 overflow-scroll rounded-2xl xl:border-1 xl:border-secondary xl:shadow-modal">
      <div className="relative hidden xl:block">
        <div className="w-full  p-2.5">
          <p className="font-satoshi text-xxs font-bold text-white xl:text-xs 4xl:text-sm">Incentives</p>
          <div className="absolute left-0 top-0 z-10 h-full w-full bg-gradient-to-l from-[#ffffff33] to-[#fff] opacity-30 " />
        </div>
      </div>
      <div className="secondary-scrollbar mx-3 mb-2 mt-5 flex w-fit flex-wrap justify-start gap-3 overflow-y-hidden overflow-x-scroll pb-4 pr-2 lg:mt-0 xl:flex-nowrap xl:justify-normal xl:px-4">
        {isLoading ? (
          <div className="flex w-full items-center justify-center">
            <div className="h-32 w-32">
              <LoadingIcon color="#102D4E" />
            </div>
          </div>
        ) : !magnetDataArr || magnetDataArr?.length === 0 ? (
          <div className="-mb-2 mt-3 flex w-full flex-col items-center justify-center rounded-lg border-1 border-dashed border-white border-opacity-50 p-8 font-satoshi font-medium text-white text-opacity-70">
            <SparklesIcon className="mb-3 h-12 w-12 text-white opacity-70" />
            No Incentive Activations yet!
          </div>
        ) : (
          <>
            {magnetDataArr.map((magnetData: any) =>
              magnetData.incentives.map((incentive: any) => (
                <IncentivesCard
                  key={incentive.id}
                  isPreview
                  incentiveData={incentive as any}
                  shareRequestsResponded={magnetData.social_share_responded_ids}
                  pollsResponded={magnetData.responded_polls_ids}
                />
              )),
            )}
          </>
        )}
      </div>
    </div>
  );
}
export default IncentivesPanel;
